<template>
    <el-drawer class="w-el-drawer" :visible.sync="visible" :size="960" :with-header="false" direction="rtl" :before-close="Close" append-to-body destroy-on-close>
        <div class="w-el-drawer-header">
            <i class="el-icon-tickets"></i> 新建信息
        </div>
        <div class="w-el-drawer-body"  v-loading="loading">
            <el-form :model="form" label-width="120px" size="mini">
                <el-form-item label="标题" :rules="[{ required: true, message: '必填项' }]" :error="formError.name?.toString()" prop="name">
                    <el-input v-model="form.name" placeholder="请输入标题" clearable />
                </el-form-item>
                <el-form-item label="分类" :rules="[{ required: true, message: '必填项' }]" :error="formError.type_id?.toString()" prop="type_id">
                    <news-type-select v-model="form.type_id" placeholder="请输入标题" clearable />
                </el-form-item>
                <el-form-item label="抄送给">
                    <users-select v-model="form.users_cc_id" multiple />
                </el-form-item>
                <el-form-item label="概述" :rules="[{ required: true, message: '必填项' }]" :error="formError.overview?.toString()" prop="overview">
                    <el-input type="textarea" :rows="2" placeholder="请输入简单的描述或备注" v-model="form.overview" />
                </el-form-item>
                <el-form-item label="内容">
                    <froala-editor v-model="form.describe" />
                </el-form-item>
                <el-form-item label="附件">
                    <files-upload v-model="form.files_id" model="news" />
                </el-form-item>
            </el-form>
        </div>
        <div class="w-el-drawer-footer">
            <el-button size="medium" @click="Close()">取 消</el-button>
            <el-button size="medium" type="primary" @click="SubmitForm()" :loading="loading">提 交</el-button>
        </div>
    </el-drawer>
</template>
<script>
export default {
    data () {
        return {
            visible: false,
            loading: false,
            formError: { },
            form: {
                name: null,
                type_id: null,
                users_cc_id: null,
                overview: null,
                describe: null,
                files_id: []
            }
        }
    },
    methods: {
        Open() {
            this.visible = true
            this.loading = false
        },
        Close() {
            this.formError = {}
            this.form.name = null
            this.form.type_id = null
            this.form.users_cc_id = null
            this.form.overview = null
            this.form.describe = null
            this.form.files_id = []
            this.visible = false
            this.loading = false
        },
        SubmitForm() {
                        this.loading = true
            this.formError = {}
                        this.$http.post('/9api/news/create', this.form).then(rps => {
                this.loading = false
                                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }
                                if (rps.data.state == 'success') {
                                        this.$notify.success({ title: '提示', message: '请求成功', duration: 2000 })
                    this.$emit('onChange', rps.data.body)
                    this.Close()
                }
            })
        },
    }
}
</script>